module.exports = __webpack_public_path__ + "img/mind_skeleton_5.0b25b8f1.png";